export default "__VITE_ASSET__CMVkgo3n__"